import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=377ed969&scoped=true"
import script from "./PreviewCard.vue?vue&type=script&lang=js"
export * from "./PreviewCard.vue?vue&type=script&lang=js"
import style0 from "./PreviewCard.vue?vue&type=style&index=0&id=377ed969&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377ed969",
  null
  
)

export default component.exports